"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/collapse/style/css");

var _collapse = _interopRequireDefault(require("antd/es/collapse"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _withStyles = _interopRequireDefault(require("react-international-telephone-input/lib/withStyles"));

var _form = _interopRequireDefault(require("antd/lib/form"));

var _user = require("../../../redux/user/user.types");

var _api = _interopRequireDefault(require("../../../redux/api"));

var _api2 = require("../../../redux/api/api.types");

var _typesafeActions = require("typesafe-actions");

require("./userCreation.scss");

var _ActivityTooltip = _interopRequireDefault(require("../../../components/activity/ActivityTooltip"));

var _HMPTextArea = _interopRequireDefault(require("../../../components/textarea/HMPTextArea"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const flagsImagePath = require("../../../assets/images/flags.png");

const {
  Item
} = _form.default;
const {
  Option
} = _select.default;
const {
  Panel
} = _collapse.default;
const {
  Password
} = _input.default;
const {
  confirm
} = _modal.default;
var UserType;

(function (UserType) {
  UserType["PARTICIPANT"] = "PARTICIPANT";
  UserType["PSEUDO"] = "PSEUDO PARTICIPANT";
  UserType["ADMIN"] = "ADMIN";
})(UserType || (UserType = {}));

const itemStyle = {
  width: 'auto',
  marginBottom: '10px',
  marginTop: '10px'
};

class UserCreationPage extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: UserType.PARTICIPANT,
      isUnsaved: false,
      usernameStatus: undefined,
      sendEmail: false,
      createPseudos: true
    };
    this.form = /*#__PURE__*/_react.default.createRef();
    this.availableUserTypes = [];

    this.onChange = () => {
      this.setState({
        isUnsaved: true
      });
    };

    this.onArmChange = value => {
      const {
        arms
      } = this.props;
      const selectedArm = arms === null || arms === void 0 ? void 0 : arms.find(a => a.id === value);

      if (!selectedArm) {
        throw Error('No selected arm during arm change handler');
      }

      this.setState({
        isUnsaved: true,
        sendEmail: false,
        createPseudos: true
      });
    };

    this.onCreatePseudosChange = e => {
      this.setState({
        createPseudos: e.target.checked
      });
      this.onChange();
    };

    this.onSendEmailChange = e => {
      this.setState({
        sendEmail: e.target.checked
      });
      this.onChange();
    };

    this.emailValidator = (rule, value) => {
      // check presence of @. (https://jira.atlassian.com/browse/CWD-2065)
      if (value && value.indexOf('@') > 0) {
        return Promise.resolve();
      }

      return Promise.reject('Please enter a valid email address.');
    };

    this.onUserTypeChange = value => {
      this.setState({
        type: value,
        sendEmail: false,
        createPseudos: true
      });
    };

    this.usernameValidator = async (rule, value) => {
      const {
        studyId
      } = this.props;
      const {
        type
      } = this.state;

      if (type === UserType.ADMIN) {
        if (!value || value.length === 0) {
          return Promise.reject('Username is a required field.');
        }

        this.setState({
          usernameStatus: 'validating'
        });
        const isUsernameAvailable = await (0, _api.default)({
          method: 'get',
          url: `/a/usmg/availability/username/${value}?isAdminUser=true&studyId=${studyId}`
        });

        if (!isUsernameAvailable.data) {
          this.setState({
            usernameStatus: 'error'
          });
          return Promise.reject('This username is already in-use.');
        }

        this.setState({
          usernameStatus: 'success'
        });
      }

      return Promise.resolve();
    };

    this.passwordValidator = (rule, value) => {
      if (this.state.sendEmail) return Promise.resolve();

      if (value && value.length < 8) {
        return Promise.reject("Please enter a password that's at least 8 characters long.");
      }

      return Promise.resolve();
    };

    this.confirmPasswordValidator = (rule, value) => {
      if (this.state.sendEmail) return Promise.resolve();

      if (value !== this.form.current.getFieldValue('password')) {
        return Promise.reject('Passwords do not match.');
      }

      return Promise.resolve();
    };

    this.handleCreateUser = () => {
      const {
        createUser,
        studyId,
        showAccessCodeEnrolment
      } = this.props;
      const {
        type,
        sendEmail,
        createPseudos
      } = this.state;
      const sendEnrollmentEmail = sendEmail && showAccessCodeEnrolment;

      if (this.form.current) {
        const {
          roleIds = [],
          username,
          password,
          studyArmId,
          email,
          firstName,
          lastName,
          dateOfBirth,
          genderIdentity,
          address1,
          mobile,
          referralCode,
          externalId
        } = this.form.current.getFieldsValue();
        const user = {
          type,
          roleIds,
          username,
          password,
          studyId,
          studyArmId,
          email,
          firstName,
          lastName,
          dateOfBirth: dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.toISOString(),
          genderIdentity,
          address1,
          mobile,
          referralCode,
          hivStatus: -1,
          externalId
        };

        if (type === UserType.PARTICIPANT && sendEnrollmentEmail) {
          user.username = undefined;
          user.password = undefined;
          user.roleIds = undefined;
        }

        if (type === UserType.ADMIN) {
          user.studyArmId = -1;
        }

        createUser({
          user,
          sendEmail: sendEnrollmentEmail,
          createPseudos: createPseudos
        });
        this.resetState();
      }
    };

    this.resetState = () => {
      this.setState({
        type: UserType.PARTICIPANT,
        isUnsaved: false,
        usernameStatus: undefined
      }, () => {
        if (this.form.current) {
          this.form.current.resetFields();
        }
      });
    };

    this.handleReset = () => {
      confirm({
        title: 'Are you sure you want to reset this form?',
        content: 'You will lose all changes.',
        okText: 'Reset',
        okType: 'danger',
        onOk: () => {
          this.resetState();
        },

        onCancel() {}

      });
    };

    this.handleSave = () => {
      if (this.form.current) {
        this.form.current.validateFields().then(() => {
          confirm({
            title: 'Are you sure you want to create this user?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              this.handleCreateUser();
            },

            onCancel() {}

          });
        });
      }
    };

    this.capitalize = s => s ? s.split(' ').map(word => word[0].toUpperCase() + word.substring(1)).join(' ') : s;

    this.availableUserTypes.push(UserType.ADMIN);
    this.availableUserTypes.push(UserType.PARTICIPANT);
    this.availableUserTypes.push(UserType.PSEUDO);
  }

  componentDidUpdate(prevProps) {
    const {
      createUserStatus,
      clearStatus
    } = this.props;

    if (!prevProps.createUserStatus.isError && createUserStatus.isError) {
      _message2.default.error('Error creating user.');

      clearStatus((0, _typesafeActions.getType)(_user.createUserAsync.failure));
    } else if (!prevProps.createUserStatus.isSuccess && createUserStatus.isSuccess) {
      _message2.default.success('User created successfully.');

      clearStatus((0, _typesafeActions.getType)(_user.createUserAsync.success));
    }
  }

  render() {
    const {
      arms,
      adminRoles,
      showReferrals,
      showAccessCodeEnrolment,
      showDOB,
      showGenderIdentity
    } = this.props;
    const {
      type,
      usernameStatus,
      sendEmail
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "form-container"
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      className: "user-creation-form",
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "announcement-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "User Creation"))
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "user-creation-form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: "type-select",
      name: "type",
      label: "Select the type of user:",
      style: itemStyle,
      rules: [{
        required: true
      }],
      initialValue: type
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      onChange: this.onUserTypeChange
    }, this.availableUserTypes.map(option => /*#__PURE__*/_react.default.createElement(Option, {
      key: `option-${option}`,
      value: option
    }, this.capitalize(option.toLowerCase()))))), type === 'ADMIN' && /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      onChange: this.onCreatePseudosChange,
      style: {
        color: '#000000d9'
      }
    }, "Create Pseudo Users?"), /*#__PURE__*/_react.default.createElement(Item, {
      key: "role-select",
      name: "roleIds",
      label: "Role:",
      hidden: type !== UserType.ADMIN,
      style: itemStyle,
      rules: [{
        required: type === UserType.ADMIN,
        message: 'Must select at least one role.'
      }]
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      mode: "multiple",
      allowClear: true,
      onChange: this.onChange
    }, adminRoles === null || adminRoles === void 0 ? void 0 : adminRoles.map(role => /*#__PURE__*/_react.default.createElement(Option, {
      key: `role-${role.id}`,
      value: role.id
    }, role.role)))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "arm-select",
      name: "studyArmId",
      hidden: type === UserType.ADMIN,
      label: "Select the study arm:",
      style: itemStyle,
      required: type !== UserType.ADMIN
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      onChange: this.onArmChange
    }, arms === null || arms === void 0 ? void 0 : arms.map(arm => /*#__PURE__*/_react.default.createElement(Option, {
      key: `arm-${arm.id}`,
      value: arm.id
    }, arm.name)))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "send-email",
      name: "sendEmail",
      hidden: type === UserType.ADMIN || !showAccessCodeEnrolment,
      required: type !== UserType.ADMIN
    }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      onChange: this.onSendEmailChange,
      style: {
        color: '#000000d9'
      }
    }, "Would you like to send the enrollment email to the user? (uncheck to enroll now)")), /*#__PURE__*/_react.default.createElement(Item, {
      key: "email-input",
      name: "email",
      label: "Email:",
      style: itemStyle,
      rules: [{
        required: true,
        validator: this.emailValidator
      }],
      validateTrigger: ['onSubmit', 'onBlur']
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "email@email.com",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "username-input",
      name: "username",
      hidden: sendEmail,
      label: "Username:",
      validateStatus: usernameStatus,
      style: itemStyle,
      rules: [{
        required: type === UserType.ADMIN || !sendEmail,
        validator: this.usernameValidator
      }],
      validateTrigger: ['onBlur', 'onSubmit']
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Username",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "password-input",
      name: "password",
      hidden: sendEmail,
      label: "Password:",
      style: itemStyle,
      rules: [{
        required: type === UserType.ADMIN || !sendEmail,
        validator: this.passwordValidator
      }],
      validateTrigger: ['onBlur', 'onChange']
    }, /*#__PURE__*/_react.default.createElement(Password, {
      visibilityToggle: true,
      placeholder: "Password",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "confirm-password-input",
      name: "confirmPassword",
      hidden: sendEmail,
      label: "Confirm Password:",
      style: itemStyle,
      rules: [{
        required: type === UserType.ADMIN || !sendEmail,
        validator: this.confirmPasswordValidator
      }],
      validateTrigger: ['onBlur', 'onChange']
    }, /*#__PURE__*/_react.default.createElement(Password, {
      visibilityToggle: true,
      placeholder: "Confirm Password",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "first-name-input",
      name: "firstName",
      label: "First Name:",
      rules: [{
        required: true,
        message: 'First name is required.'
      }],
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "First name",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "last-name-input",
      name: "lastName",
      label: "Last Name:",
      rules: [{
        required: true,
        message: 'Last name is required.'
      }],
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Last name",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "mobile-input",
      name: "mobile",
      label: "Mobile Phone:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Mobile phone is required.'
      }]
    }, /*#__PURE__*/_react.default.createElement(_withStyles.default, {
      flagsImagePath: flagsImagePath
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "external-id-input",
      name: "externalId",
      label: "External Id:",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(_collapse.default, null, /*#__PURE__*/_react.default.createElement(Panel, {
      header: "Optional",
      key: "0"
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: "dob-input",
      name: "dateOfBirth",
      hidden: !showDOB,
      label: "Date of Birth:",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "gender-identity-input",
      name: "genderIdentity",
      hidden: !showGenderIdentity,
      label: "Gender Identity:",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Gender Identity",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "address-input",
      name: "address1",
      label: "Address"
    }, /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      placeholder: "Address",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "referral-input",
      name: "referralCode",
      hidden: showReferrals,
      label: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Referral Code: "), /*#__PURE__*/_react.default.createElement(_ActivityTooltip.default, {
        text: "Referral code of the participant who is referring the user you are creating"
      })),
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Referral Code",
      onChange: this.onChange
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "actions"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "action",
      type: "default",
      onClick: this.handleReset
    }, "Reset"), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "action",
      type: "primary",
      onClick: this.handleSave
    }, "Save")))));
  }

}

const mapStateToProps = state => {
  return {
    adminRoles: selectors.getAdminRoles(state),
    studyId: selectors.getRequestedStudyId(state),
    arms: selectors.getRequestedStudyStudyArms(state),
    createUserStatus: selectors.createUserStatus(state),
    showReferrals: selectors.getReferralsFeatureEnabled(state),
    showAccessCodeEnrolment: selectors.getAccessCodeEnrollmentEnabled(state),
    showDOB: selectors.getShowDOBEnrollmentEnabled(state),
    showGenderIdentity: selectors.getShowGenderIdentityEnrollmentEnabled(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createUser: args => dispatch(_user.createUserAsync.request(args)),
    clearStatus: type => dispatch((0, _api2.clearStatus)(type))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserCreationPage);

exports.default = _default;